import {
  AudioContent,
  ContentGUID,
  DocumentContent,
  Enrollment,
  EnrollmentComponent,
  ScormContent,
  VideoContent,
  PreloadSettings,
  PreloadResource,
} from '../shared/types/common.model';
import { TextContent } from '../shared/types/common.model';

/**
 * Content Delivery Client define the interface between concrete client classes and the data model in the container components.
 */
export interface ContentDeliveryClient {
  getCourseModules(): Promise<EnrollmentComponent[]>;

  getText(options: ContentGUID & { signal?: AbortSignal }): Promise<TextContent>;

  getAudio(options: ContentGUID & { signal?: AbortSignal }): Promise<AudioContent>;

  getDocument(options: ContentGUID & { signal?: AbortSignal }): Promise<DocumentContent>;

  getVideo(options: ContentGUID & { signal?: AbortSignal }): Promise<VideoContent>;

  getScorm(options: ContentGUID & { signal?: AbortSignal }): Promise<ScormContent>;

  getEnrollment(): Promise<Enrollment>;

  getEnrollmentComponent(): Promise<EnrollmentComponent>;

  getFlags(): Promise<Record<string, unknown>>;

  getOnDescriptionPage(): Promise<boolean>;

  getIsPreview(): Promise<boolean>;

  getSettings(): Promise<PreloadSettings>;

  getWasJustCompleted(): Promise<boolean>;

  getSocialSharing(): Promise<PreloadResource['social_sharing']['attributes']>;

  getAwardedBadges(): Promise<PreloadResource['awarded_badges']['data']>;

  getNextCourseOnPath(): Promise<PreloadResource['next_course_on_path_id']>;

  getEmbeddingSettings(): Promise<{
    hide_module_sidebar: PreloadResource['hide_module_sidebar'];
    embedded_content: PreloadResource['embedded_content'];
    embedded_content_autoplay: PreloadResource['embedded_content_autoplay'];
  }>;

  getScormSettings(): Promise<{
    tincan_completion_tracking: boolean;
  }>;

  getPortalFeatureFlags(): Promise<{
    content_details_redesign_enabled: boolean;
    concurrent_and_series_sessions: boolean;
  }>;
}

export class ContentDeliveryClientError extends Error {
  constructor(
    message: string,
    public details?: unknown
  ) {
    super(message);
    this.name = 'ContentDeliveryClientError';
    this.details = details;
  }
}
